import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: '#5087e6',
            secondary: colors.grey.darken1,
            accent: colors.shades.black,
            error: colors.red.accent3,
            background: colors.indigo.lighten5, // Not automatically applied
          },
          dark: {
            avatar: "#757575",
            primary: '#5087e6',
            background: '#A03E4D', // If not using lighten/darken, use base to return hex
            
          },
        },
    },
});
